import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { Controller, useForm } from "react-hook-form";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { ButtonGroup, FormControl, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BsEmojiFrownFill,
  BsFillEmojiNeutralFill,
  BsFillEmojiSmileFill,
} from "react-icons/bs";

import { getItemFromStorage } from "../../../../../system";
import {
  emptyString,
  roleTypeEnums,
  loginConstants,
  managerDropDown,
  groupsConstants,
  inputFieldNames,
  franchiseDropDown,
  userBrandDropDown,
  reactSelectStylingConst,
  userPermissionsConstants,
  profileTypeDropdownNames,
  userPermissionsFieldsNames,
  responseTypeIconColors,
  userSuperAdminDropDown,
  surveyQuestionsConstants,
  BUTTON_TEXT,
  STYLES,
  EMPTY_ARRAY_LENGTH,
} from "../../../constants";
import { managersConstants } from "../../../../group-screens/constants";
import { storesConstants } from "../../../../admin-screens/constants";

import {
  useSpinner,
  Option,
  ValueContainer,
  getClassName,
  getOptionLabel,
  getOptionStyle,
  isSuperOrBrandAdmin,
  loadingIndicator,
  GenericModal,
  handleAsyncAction,
} from "../../../../../shared";
import { managersActions } from "../../../../group-screens/redux/actions";
import { groupsActions, userPermissionsActions } from "../../../redux/actions";

const {
  ROLE,
  GROUP,
  BRANDS,
  GROUPS,
  MANAGER,
  BRAND_ADMIN,
  SUPER_ADMIN,
  PROFILE_TYPE,
  FRANCHISE_ID,
} = userPermissionsConstants;

const { scarlet, ashGrey, borderRadius, minHeight, boxShadow } =
  reactSelectStylingConst;
const { BRAND_ID } = userPermissionsFieldsNames;
const { BRAND_LOCATIONS_IDS } = inputFieldNames;

//Configuration for modal
const ModalConfiguration = {
  size: "md",
  animate: true,
  addBtnText: BUTTON_TEXT.ADD,
  newBtnText: BUTTON_TEXT.NEW,
  backBtnText: BUTTON_TEXT.BACK,
  submitBtnText: BUTTON_TEXT.UPDATE,
  cancelBtnText: BUTTON_TEXT.CLOSE,
  submitBtnVariant: "dark",
  newButtonVariant: "primary",
  cancelBtnVariant: "outline-dark",
};

const AllResponsesModal = (props) => {
  const {
    list,
    isOpen,
    groups,
    allBrands,
    getGroups,
    userDetails,
    allLocations,
    isOpenToggle,
    setSwapModal,
    searchString,
    responseType,
    responseHandle,
    getBrandlocations,
    addUserPermission,
    getSurveyRecipients,
    handleSearchRecipients,
    allResponsesHandleSubmit,
    getUserPermissionByBrandId,
    getUserPermissionByGroupId,
  } = props;

  let localRole = getItemFromStorage(loginConstants.ROLE);

  const { brandId: paramBrandId, groupId } = useParams();

  let recipientModalRef = useRef(null);
  const currentBrandId = isSuperOrBrandAdmin() ? paramBrandId : userDetails?.brandId

  const [rowData, setRowData] = useState({});
  const [newUser, setNewUser] = useState(false);
  const [brandName, setBrandName] = useState({});
  const [franchiseName, setFranchiseName] = useState({});
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState(
    rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH ? rowData?.storeIds : []
  );
  const {
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // Show loading while a request is running.
  const spinner = useSpinner();

  //The modal closes only once the update succeeds, so block a second submit while it is in flight
  const isUpdatingRecipients =
    spinner(surveyQuestionsConstants.UPDATE_RECIPIENTS);

  //Clears the "add new recipient" draft so the form always opens blank
  const resetNewUserForm = () => {
    setRowData({});
    setBrandName({});
    setFranchiseName({});
    setStores([]);
    setSelectedStores([]);
    reset();
  };

  //Switching between the recipient list and the new recipient form discards the draft
  const toggleNewUserForm = (showNewUserForm) => {
    resetNewUserForm();
    setNewUser(showNewUserForm);
  };

  //Function to close popup
  const CloseModal = () => {
    isOpenToggle();
    setNewUser(false);
    setSwapModal(false);
    resetNewUserForm();
  };

  //Custome styles for react select
  const styleReactSelect = (error, value) => {
    return {
      control: (styles) => ({
        ...styles,
        borderRadius: borderRadius,
        minHeight: minHeight,
        borderColor: error && !value ? scarlet : ashGrey,
        "&:hover": {
          borderColor: error && !value ? scarlet : ashGrey,
        },
        boxShadow: boxShadow,
      }),
    };
  };

  //Function to set name of profile type dropdown
  const handleProfileTypeName = (roleId) => {
    if (roleId === roleTypeEnums.BRAND_ADMIN) {
      return profileTypeDropdownNames.BRAND_ADMIN;
    } else if (roleId === roleTypeEnums.GROUP) {
      return profileTypeDropdownNames.GROUP;
    } else if (roleId === roleTypeEnums.MANAGER) {
      return profileTypeDropdownNames.MANAGER;
    } else if (roleId === roleTypeEnums.EMAIL_ONLY) {
      return profileTypeDropdownNames.EMAIL_ONLY;
    } else {
      return PROFILE_TYPE;
    }
  };

  //Function to handle change in add new user fields
  const handleChange = (e, flag, fieldName) => {
    if (flag) {
      if (fieldName === BRAND_ID) {
        delete rowData?.groupId;
        setRowData({
          ...rowData,
          [fieldName]: e.value || e.id,
        });
        resetSelectedStores();
        setFranchiseName([]);
      } else {
        setRowData({
          ...rowData,
          [fieldName]: e.value || e.id,
        });
      }
    } else {
      const { name, value } = e.target;
      setRowData({
        ...rowData,
        [name]: value,
      });
    }
  };

  //Handle brand change function to save changes in state
  const handleBrandChange = (e) => {
    let brandId = e.id;

    if (
      brandId &&
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY)
    ) {
      getGroups(brandId);
    }
    handleChange(e, true, "brandId");
  };

  const handleFranchiseSelect = (e, flag, fieldName) => {
    setFranchiseName(e);
    handleChange(e, flag, fieldName);
    if (
      (rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY) &&
      e.id
    ) {
      getBrandlocations(e.id);
    }
  };

  //Function to show add new user fields
  const addNewUser = () => {
    let obj = {
      ...rowData,
      name: rowData?.name,
      email: rowData?.email,
      roleId: rowData?.roleId,
    };
    if (rowData?.roleId === roleTypeEnums.BRAND_ADMIN) {
      obj = {
        ...obj,
        brandId: rowData?.brandId,
        brandIds: [rowData?.brandId],
      };
    } else if (rowData?.roleId === roleTypeEnums.GROUP) {
      obj = {
        ...obj,
        brandId: rowData?.brandId,
        groupId: rowData?.groupId,
      };
    } else if (rowData?.roleId === roleTypeEnums.MANAGER) {
      obj = {
        ...obj,
        brandId: rowData?.brandId,
        groupId: rowData?.groupId,
        managerId: rowData?.managerId,
      };
    }

    handleAsyncAction(addUserPermission(obj), {
      onSuccess: () => {
        if (localRole === GROUP) {
          getUserPermissionByGroupId(groupId);
        } else if (isSuperOrBrandAdmin()) {
          getUserPermissionByBrandId(paramBrandId);
        }
        if (localRole !== SUPER_ADMIN && allBrands?.length) {
          getGroups(allBrands[0]?.id);
        }
        getSurveyRecipients(currentBrandId);
        CloseModal();
      },
    });
  };

  const profileTypeOptions = () => {
    let option = [{ value: emptyString, name: PROFILE_TYPE }];

    switch (localRole) {
      case SUPER_ADMIN:
        return [...option, ...userSuperAdminDropDown];
      case BRAND_ADMIN:
        return [...option, ...userBrandDropDown];
      case GROUP:
        return [...option, ...franchiseDropDown];
      case MANAGER:
        return [...option, ...managerDropDown];
      default:
        return []; // Empty options array for other roles or no role specified
    }
  };

  const renderProfileTypeSelect = () => (
    <Form.Group className="mb-2">
      <div className="row align-items-center">
        <div className="col-3">
          <Form.Label htmlFor="profileType">Profile Type:</Form.Label>
        </div>
        <div className="col-9">
          <Controller
            name="roleId"
            id="profileType"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={{
                  value: rowData?.roleId || emptyString,
                  name: handleProfileTypeName(rowData?.roleId),
                }}
                options={profileTypeOptions()}
                components={{
                  IndicatorSeparator: () => null,
                }}
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => option.name}
                onChange={(e) => {
                  handleChange(e, true, ROLE);
                }}
                placeholder={PROFILE_TYPE}
                isSearchable={true}
                styles={styleReactSelect(errors.roleId, rowData?.roleId)}
                className="w-100 font-14-px text-secondary"
              />
            )}
            rules={{ required: !rowData?.roleId }}
          />
        </div>
      </div>
    </Form.Group>
  );

  //Handle Change function to set rowData and checkedItems
  const handleSelectedStores = (e) => {
    const { name, value } = e.target || e;

    setRowData({ ...rowData, [name]: value });
  };

  //Function to reset states
  const resetSelectedStores = () => {
    setSelectedStores([]);
    setRowData((previousValue) => ({
      ...previousValue,
      storeIds: [],
    }));
  };

  const shouldHideBasedOnRole = () => {
    const { roleId, brandId, groupId, storeIds } = rowData || {};

    const shouldHide = !(
      roleId === roleTypeEnums.SUPER_ADMIN ||
      (roleId === roleTypeEnums.BRAND_ADMIN && brandId) ||
      (roleId === roleTypeEnums.GROUP && brandId && groupId) ||
      ((roleId === roleTypeEnums.MANAGER ||
        roleId === roleTypeEnums.EMAIL_ONLY) &&
        brandId &&
        groupId &&
        storeIds &&
        rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH)
    );

    return shouldHide;
  };

  const initialRender = useRef(true);
  useEffect(() => {
    const isManagerOrGroupWithBrandId =
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER) &&
      rowData?.brandId;

    if (initialRender.current) {
      initialRender.current = false;
    } else if (isManagerOrGroupWithBrandId) {
      getGroups(rowData?.brandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.brandId, rowData?.roleId]);

  const initialRenderForLocations = useRef(true);
  useEffect(() => {
    const isManagerWithBrandAndGroupId =
      rowData?.roleId === roleTypeEnums.MANAGER &&
      rowData?.brandId &&
      rowData?.groupId;

    if (initialRenderForLocations.current) {
      initialRenderForLocations.current = false;
    } else if (isManagerWithBrandAndGroupId) {
      getBrandlocations(rowData?.groupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.groupId]);

  //Getting names against brandId, locationId and groupId
  useEffect(() => {
    //If allBrands from reducers is present then execute the following
    if (allBrands) {
      let obj = allBrands?.find((brand) => brand.id === rowData?.brandId);
      setBrandName(obj);
    }
    //If groups from reducers is present then execute the following
    if (groups) {
      let obj = groups?.find((group) => group.id === rowData?.groupId);
      setFranchiseName(obj);
      if (
        obj === undefined &&
        rowData?.roleId !== roleTypeEnums.BRAND_ADMIN &&
        rowData?.roleId !== undefined
      ) {
        setRowData({ ...rowData, groupId: emptyString });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBrands, groups]);

  //Auto select functionality for every role
  useEffect(() => {
    if (localRole === GROUP && groups?.length && allBrands?.length) {
      setRowData({
        ...rowData,
        brandId: allBrands[0]?.id,
        groupId: groups[0]?.id,
      });
    } else if (localRole === MANAGER && allBrands?.length) {
      setRowData({
        ...rowData,
        brandId: allBrands[0]?.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups, newUser]);

  //Auto Select functionality for every role
  useEffect(() => {
    if (!isSuperOrBrandAdmin() && allBrands?.length) {
      setRowData({ ...rowData, brandId: allBrands[0].id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBrands, newUser]);

  useEffect(() => {
    if (allLocations) {
      setStores(allLocations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocations]);

  const renderBrandDropDown = () => (
    <Form.Group
      className={`mb-2 ${JSON.stringify(rowData) === JSON.stringify({}) || !rowData?.roleId
        ? "d-none"
        : emptyString
        }`}
      data-testid="brand-dropDown"
    >
      <div className="row align-items-center">
        <div className="col-3">
          <Form.Label>Brand:</Form.Label>
        </div>
        <div className="col-9">
          <Controller
            name="brandId"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={
                  !isSuperOrBrandAdmin()
                    ? allBrands
                    : [
                      {
                        id: brandName?.id || emptyString,
                        name: brandName?.name || BRANDS,
                      },
                    ]
                }
                options={
                  localRole === SUPER_ADMIN
                    ? [
                      { id: emptyString, name: BRANDS },
                      ...allBrands.filter(
                        // eslint-disable-next-line eqeqeq
                        (obj) => obj.id == paramBrandId
                      ),
                    ]
                    : allBrands.filter((obj) => {
                      // eslint-disable-next-line eqeqeq
                      return (
                        obj.id ===
                        (userDetails?.brandId || Number(paramBrandId))
                      );
                    })
                }
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: loadingIndicator,
                }}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                onChange={(e) => {
                  setBrandName(e);
                  handleBrandChange(e);
                }}
                placeholder={BRANDS}
                isSearchable={true}
                styles={styleReactSelect(errors.brandId, rowData?.brandId)}
                className="w-100 font-14-px text-secondary"
                id="brandId"
                isLoading={spinner(storesConstants.FETCH_ALL_BRANDS)}
                isDisabled={spinner(storesConstants.FETCH_ALL_BRANDS)}
              />
            )}
            rules={{
              required: !(rowData?.brandId || localRole !== SUPER_ADMIN),
            }}
          />
        </div>
      </div>
    </Form.Group>
  );

  const renderGroupDropDown = () => (
    <Form.Group
      className={`mb-2 ${JSON.stringify(rowData) === JSON.stringify({}) ||
        !rowData?.roleId ||
        rowData?.roleId === roleTypeEnums.BRAND_ADMIN ||
        !rowData?.brandId
        ? "d-none"
        : emptyString
        }`}
      data-testid="franchise-dropDown"
    >
      <div className="row align-items-center">
        <div className="col-3">
          <Form.Label> Groups:</Form.Label>
        </div>
        <div className="col-9">
          <Controller
            name="groupId"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={
                  localRole === GROUP
                    ? groups || []
                    : [
                      {
                        id: franchiseName?.id || emptyString,
                        name: franchiseName?.name || GROUPS,
                      },
                    ]
                }
                options={
                  localRole !== GROUP
                    ? [{ id: emptyString, name: GROUPS }, ...(groups || [])]
                    : groups
                }
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: loadingIndicator,
                }}
                getOptionValue={(option) => option.id}
                getOptionLabel={getOptionLabel}
                onChange={(e) => {
                  handleFranchiseSelect(e, true, FRANCHISE_ID);
                  resetSelectedStores();
                }}
                placeholder={GROUPS}
                isSearchable={true}
                styles={{
                  ...styleReactSelect(errors.groupId, rowData?.groupId),
                  option: getOptionStyle,
                }}
                className="w-100 font-14-px text-secondary"
                id="groupId"
                isDisabled={
                  spinner(groupsConstants.GROUPS_DATA) || !rowData?.brandId
                }
                isLoading={spinner(groupsConstants.GROUPS_DATA)}
              />
            )}
            rules={{
              required: !(
                rowData?.groupId ||
                rowData?.roleId === roleTypeEnums.BRAND_ADMIN
              ),
            }}
          />
        </div>
      </div>
    </Form.Group>
  );

  const renderStoresDropDown = () => (
    <Form.Group
      className={`mb-2 ${JSON.stringify(rowData) === JSON.stringify({}) ||
        !rowData?.roleId ||
        rowData?.roleId === roleTypeEnums.BRAND_ADMIN ||
        rowData?.roleId === roleTypeEnums.GROUP ||
        !rowData?.groupId
        ? "d-none"
        : emptyString
        }`}
      data-testid="manager-dropDown"
    >
      <div className="row align-items-center">
        <div className="col-3">
          <Form.Label> Stores:</Form.Label>
        </div>
        <div className="col-9">
          <Controller
            name="storeIds"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={selectedStores}
                closeMenuOnSelect={false}
                options={stores}
                components={{
                  Option,
                  ValueContainer: ValueContainer,
                  IndicatorSeparator: () => null,
                  LoadingIndicator: loadingIndicator,
                }}
                isMulti
                hideSelectedOptions={false}
                maxMenuHeight={200}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                onChange={(e) => {
                  let obj = {
                    name: BRAND_LOCATIONS_IDS,
                    value: e.map((loc) => loc.id),
                    checked: true,
                  };
                  handleSelectedStores(obj);
                  setSelectedStores(e);
                }}
                placeholder="Select Stores"
                isSearchable={true}
                styles={{
                  ...styleReactSelect(
                    errors.storeIds,
                    rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH
                      ? rowData?.storeIds[0]
                      : undefined
                  ),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: state.isSelected
                      ? "transparent"
                      : emptyString,
                    color: "black",
                  }),
                }}
                className="w-100 font-14-px text-secondary"
                id="storeIds"
                isDisabled={
                  !rowData?.groupId ||
                  spinner(managersConstants.MANAGERS_DATA)
                }
                isLoading={spinner(managersConstants.MANAGERS_DATA)}
              />
            )}
            rules={{
              required: !(
                (rowData?.storeIds && rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH) ||
                rowData?.roleId === roleTypeEnums.BRAND_ADMIN ||
                rowData?.roleId === roleTypeEnums.GROUP
              ),
            }}
          />
        </div>
      </div>
    </Form.Group>
  );

  const renderNewUserContent = () => (
    <div className="addRecepientsModal mb-5" ref={recipientModalRef}>
      <p>
        A verification Email will be sent to the new user who will be required
        to complete registration prior to receiving survey responses
      </p>

      {renderProfileTypeSelect()}
      {renderBrandDropDown()}
      {renderGroupDropDown()}
      {renderStoresDropDown()}

      <div className={` ${shouldHideBasedOnRole() ? "d-none" : ""}`}>
        <Form.Group className="mb-2">
          <div className="row align-items-center">
            <div className="col-3">
              <Form.Label>Name:</Form.Label>
            </div>
            <div className="col-9">
              <Form.Control
                type="text"
                name="name"
                value={rowData?.name}
                minLength={1}
                maxLength={100}
                {...register("name", {
                  required: !rowData?.name,
                  onChange: (e) => handleChange(e),
                })}
                className={`form-control font-14-px text-secondary ${getClassName(
                  errors.name,
                  STYLES.IS_INVALID
                )}`}
              />
            </div>
          </div>
        </Form.Group>
        <Form.Group className="mb-2">
          <div className="row align-items-center">
            <div className="col-3">
              <Form.Label htmlFor="email">Email:</Form.Label>
            </div>
            <div className="col-9">
              <Form.Control
                id="email"
                type="text"
                name="email"
                value={rowData?.email}
                minLength={1}
                maxLength={100}
                {...register("email", {
                  required: !rowData?.email,
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Email is not valid",
                  },
                  onChange: (e) => handleChange(e),
                })}
                className={`form-control font-14-px text-secondary ${getClassName(
                  errors.email,
                  STYLES.IS_INVALID
                )}`}
              />
            </div>
          </div>
        </Form.Group>
      </div>
    </div>
  );

  const renderRecipientListContent = () => (
    <>
      <div className="input-group mb-2">
        <span className="input-group-text bg-white text-secondary">
          <FontAwesomeIcon icon={faSearch} />
        </span>
        <FormControl
          placeholder="Search Recipients"
          type="text"
          className="form-control rounded-end"
          onChange={(e) => handleSearchRecipients(e.target.value)}
          value={searchString}
        />
      </div>
      <div
        className="addRecepientsModal overflow-auto pe-1"
        ref={recipientModalRef}
      >
        {renderRecipientList()}
      </div>
    </>
  );

  const isDisabledForEmailOnly = (value, currentUserRole) => {
    const hasEmailOnlyRole =
      value.user?.roleId === roleTypeEnums.EMAIL_ONLY ||
      value.roleId === roleTypeEnums.EMAIL_ONLY;
    return hasEmailOnlyRole && currentUserRole !== SUPER_ADMIN;
  };

  const renderRecipientList = () => {
    if (list.length) {
      return (
        <>
          {list.map((val, index) => {
            const userId = val.userId || val.id;
            return (
              <div
                key={userId}
                className="d-flex align-items-center justify-content-between mb-2 p-1 vh-50 overflow-auto"
                data-testid="all-responses-emails"
              >
                <div className="me-2 recipients_email">
                  {val.user?.email || val.email}
                </div>
                <div>
                  <ButtonGroup size="sm">
                    <input
                      type="checkbox"
                      className="btn-check"
                      name={`positive-emoji-${userId}`}
                      value={responseType.POSITIVE}
                      id={`positiveResponse-${userId}`}
                      checked={val.positiveResponseId === responseType.POSITIVE}
                      disabled={isDisabledForEmailOnly(val, localRole)}
                      onChange={(e) =>
                        responseHandle(Number(e.target.value), index)
                      }
                    />
                    <label
                      className="btn btn-outline-success border-dark"
                      htmlFor={`positiveResponse-${userId}`}
                    >
                      <BsFillEmojiSmileFill
                        className="mx-1"
                        size={17}
                        color={
                          val.positiveResponseId === responseType.POSITIVE
                            ? responseTypeIconColors.DEFAULT_COLOR
                            : responseTypeIconColors.POSITIVE
                        }
                      />
                    </label>
                    <input
                      type="checkbox"
                      className="btn-check"
                      name={`passive-emoji-${userId}`}
                      value={responseType.PASSIVE}
                      id={`passiveResponse-${userId}`}
                      checked={val.passiveResponseId === responseType.PASSIVE}
                      disabled={isDisabledForEmailOnly(val, localRole)}
                      onChange={(e) =>
                        responseHandle(Number(e.target.value), index)
                      }
                    />
                    <label
                      className="btn btn-outline-warning border-dark text-warning-dark"
                      htmlFor={`passiveResponse-${userId}`}
                    >
                      <BsFillEmojiNeutralFill
                        className="mx-1"
                        size={17}
                        color={
                          val.passiveResponseId === responseType.PASSIVE
                            ? responseTypeIconColors.DEFAULT_COLOR
                            : responseTypeIconColors.PASSIVE
                        }
                      />
                    </label>
                    <input
                      type="checkbox"
                      className="btn-check"
                      name={`negative-emoji-${userId}`}
                      value={responseType.NEGATIVE}
                      id={`negativeResponse-${userId}`}
                      checked={val.nagetiveResponseId === responseType.NEGATIVE}
                      disabled={isDisabledForEmailOnly(val, localRole)}
                      onChange={(e) =>
                        responseHandle(Number(e.target.value), index)
                      }
                    />
                    <label
                      className="btn btn-outline-danger border-dark text-outline-dark"
                      htmlFor={`negativeResponse-${userId}`}
                    >
                      <BsEmojiFrownFill
                        className="mx-1"
                        size={17}
                        color={
                          val.nagetiveResponseId === responseType.NEGATIVE
                            ? responseTypeIconColors.DEFAULT_COLOR
                            : responseTypeIconColors.NEGATIVE
                        }
                      />
                    </label>
                  </ButtonGroup>
                </div>
              </div>
            );
          })}
        </>
      );
    }

    return <div className="text-center">No Recipients Available</div>;
  };

  const renderModalContent = () => {
    if (newUser) {
      return renderNewUserContent();
    }
    return renderRecipientListContent();
  };

  return (
    <GenericModal
      reset={reset}
      isOpen={isOpen}
      newUser={newUser}
      onClose={CloseModal}
      newButtonFlag={true}
      title="Add Recipients"
      setNewUser={toggleNewUserForm}
      addNewUser={addNewUser}
      setRowData={setRowData}
      handleSubmit={handleSubmit}
      configuration={ModalConfiguration}
      onSubmit={allResponsesHandleSubmit}
      isSubmitDisabled={isUpdatingRecipients}
    >
      {renderModalContent()}
    </GenericModal>
  );
};

const mapStateToProps = (state) => ({
  stores: state.storesReducer.stores,
  userDetails: state.authentication.user,
  groups: state.groupsReducer.groups?.data,
  allBrands: state.storesReducer.allBrands,
  allManagers: state.managersReducer.managers?.data,
  allLocations: state.managersReducer.allLocations?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getGroups: (brandId) => dispatch(groupsActions.getGroups(brandId)),
  addUserPermission: (rowData) =>
    dispatch(userPermissionsActions.addUserPermission(rowData)),
  getUserPermissionByBrandId: (brandId) =>
    dispatch(userPermissionsActions.getUserPermissionByBrandId(brandId)),
  getUserPermissionByGroupId: (groupId) =>
    dispatch(userPermissionsActions.getUserPermissionByGroupId(groupId)),
  getBrandlocations: (groupId) =>
    dispatch(managersActions.getBrandlocations(groupId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllResponsesModal);
